import Errors from './Errors';

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.headers = {};
        this.originalData = data;
        for (let field in data) {
            this[field] = data[field]
        }
        this.errors = new Errors ();
    }

    setOriginalData(data){
        this.originalData = data;
        for (let field in data) {
            this[field] = data[field]
        }
    }

    validURL(str = '', protocol = '') {
        
        if (!str) return {
            isValid: true
        }
        if (str) str = str.trim ()
        
        var pattern = new RegExp ('^(https?:\\/\\/)?' + // protocol
                                  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                                  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                                  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                                  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                                  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        
        let regHttp = /^http:\/\//;
        let regHttps = /^https:\/\//;
        
        if (regHttp.test (str) || regHttps.test (str)) {
            return {
                isValid: pattern.test (str),
                defaultRe: "1",
                hasProtocol: regHttp.test (str) || regHttps.test (str),
                url: str
            }
        }
        
        if (!pattern.test (str)) {
            return {
                isValid: pattern.test (str),
                defaultRe: "2",
                hasProtocol: regHttp.test (str) || regHttps.test (str),
                url: !pattern.test (str) ? str : (protocol + str).toString ()
            }
        }
        
        return {
            isValid: pattern.test (str),
            defaultRe: "yup",
            hasProtocol: regHttp.test (str) || regHttps.test (str),
            url: pattern.test (str) ? (protocol + str).toString () : str
        }
    }
    
    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }
        data['form'] = "formInstance";
        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = null;
        }
        this.errors.clear ();
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url, data, headers) {      
        return this.submit ('post', data, headers, url);
    }

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url, data, headers) {
        if (!headers) this.headers = headers;
        return this.submit ('put', data, headers, url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit ('patch', url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit ('delete', url);
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, data, headers, url) {
        if (!headers) headers = this.headers;
        let formData = (typeof data != "undefined") ? data : this.data ();
        return new Promise ((resolve, reject) => {
            axios[requestType] (url, formData, headers)
                .then (response => {
                    this.onSuccess (response.data, requestType);
                    resolve (response.data);
                })
                .catch (error => {
                    this.onFail (error.response.data.errors);
                    reject (error.response);
                });
        })
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data, requestType, formRequestType) {
        if (requestType != 'put' && formRequestType != 'put')
            this.reset ();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        return this.errors.record (errors)
    }

    getProviderFromEmail(email) {
        return email.split ('@')[1]
    };

    getDomainFromURL(email) {
        var url = this.getProviderFromEmail (email);
        return url;
    };

    /* cleanError() {
     
     return this.errors.clear(event.target.name);

     }*/
    /**
     * Get
     *
     * @param {object}
     */
    get(somthing) {
        return ''
    }


}

export default Form;
